import { useEffect, useState } from "react";
import { useSpinner } from '@components/SpinnerContext';
import Page404 from '@pages/NotFoundPage';
import { useLocation } from "react-router-dom";
import accomodationService from "@services/accomodation.service";
import { CardInfoTranslation } from "@models/card-info-translation.model";
import PageCardInfoList from "@components/CardInfoListPage";

const CardListPage = ()=>{

  const { showSpinner, hideSpinner } = useSpinner();
  const [isPageNotFound, setIsPageNotFound] = useState(false);
  const location = useLocation();
  const [cardInfo, setcardInfo] = useState<CardInfoTranslation[]|undefined>(undefined);
  
  useEffect(()=>{
    async function getHomePageData(id: number) {
          try {
            showSpinner()
            const response = await accomodationService.getCardInfoFromIdParent(id)
            setcardInfo(response)
          } catch (error) {
            setIsPageNotFound(true)
            console.log(error);
          }finally{
            hideSpinner()
          }
        }
        
        const parts = location.pathname.split("/").filter(Boolean);
        const id = parts[parts.length - 1];
        
        getHomePageData(parseInt(id));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[location.pathname])

return (
  <div className="">
  {isPageNotFound ? (<Page404/>):(<PageCardInfoList cardInfoList={cardInfo} />)}
  </div>
)};
export default CardListPage;